// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"3d084f5b","703":"49c25115","787":"dd5805ca"}[chunkId] + ".chunk.js";
};